import { ComponentRoute } from '@/classes'

const PrintPreviewRoutes = {
  PrintPreview: new ComponentRoute('/printpreview/:reportName', 'PrintPreview'),
  PrintPreviewOld: new ComponentRoute('/printpreviewold/:reportName', 'PrintPreviewOld'),
  PrintPreviewWithSideView: new ComponentRoute('/PrintPreviewWithSideView/:reportName', 'PrintPreviewWithSideView')
}

export default PrintPreviewRoutes
